module.exports = __webpack_public_path__ + "img/benefit-03-cert-3.c923a65f.png";